module.exports = __webpack_public_path__ + "media/images/settings-efa3c3a778a1b4bb7b695c5a35cc8c3d.svg";